import { Controller } from '@hotwired/stimulus';

// Adds .is-scrollable to the wrap element when the inner scrollable
// content actually overflows. Used by .play-history-strip-wrap to show
// the right-edge fade + chevron only when there's somewhere to scroll.
export default class extends Controller {
  static targets = ['inner'];

  connect() {
    this._update = this.update.bind(this);
    this.update();
    window.addEventListener('resize', this._update);
  }

  disconnect() {
    window.removeEventListener('resize', this._update);
  }

  update() {
    const inner = this.hasInnerTarget ? this.innerTarget : this.element.firstElementChild;
    if (!inner) return;
    const scrollable = inner.scrollWidth > inner.clientWidth + 1;
    this.element.classList.toggle('is-scrollable', scrollable);
  }
}
